import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Stake from "./Stake";

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/" element={<Stake />} />
          <Route path="/*" element={<Stake />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
